module.exports = __webpack_public_path__ + "img/電気回路_6_5_3.47607939.png";